var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "11px",
    fill: "current",
    viewBox: "0 0 16 11",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Combined Shape")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inbound_hubspot_alt_5",
    transform: "translate(-320.000000, -575.000000)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(0.000000, 568.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(16.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.99993,10.1428705 C315.210845,10.1428705 317.980072,7.09651786 318.800481,6.09926494 C317.978666,5.10232452 315.203814,2.05494059 311.99993,2.05494059 C308.789014,2.05494059 306.019787,5.10126202 305.199379,6.09854619 C306.02085,7.09495536 308.795889,10.1428705 311.99993,10.1428705 Z M319.898328,5.78770153 C320.033891,5.97301457 320.033891,6.22479656 319.898328,6.41026585 C319.75539,6.60561017 316.349661,11.1978111 311.99993,11.1978111 C307.650198,11.1978111 304.244313,6.60564142 304.101532,6.4101096 C303.966156,6.22460906 303.966156,5.97301457 304.101532,5.78751403 C304.244313,5.5921697 307.650198,1 311.99993,1 C316.349661,1 319.75539,5.5921697 319.898328,5.78770153 Z M311.99993,8.20880237 C313.163371,8.20880237 314.109811,7.26233085 314.109811,6.09892119 C314.109811,4.93551153 313.163339,3.98904001 311.99993,3.98904001 C310.83652,3.98904001 309.890049,4.93551153 309.890049,6.09892119 C309.890049,7.26233085 310.836489,8.20880237 311.99993,8.20880237 Z M311.99993,2.93406817 C313.744997,2.93406817 315.164783,4.35385358 315.164783,6.09892119 C315.164783,7.8439888 313.744997,9.26377421 311.99993,9.26377421 C310.254862,9.26377421 308.835077,7.8439888 308.835077,6.09892119 C308.835077,4.35385358 310.254862,2.93406817 311.99993,2.93406817 Z",
    id: "Combined-Shape"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.adc6532d.svg";
export { ForwardRef as ReactComponent };